/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Create_New_ListInputs */



/**
* | output |
* | --- |
* | "Create New List" |
*
* @param {Create_New_ListInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const create_new_list = /** @type {((inputs?: Create_New_ListInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Create_New_ListInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Créer une nouvelle liste")
	if (locale === "de") return /** @type {LocalizedString} */ ("Neue Liste erstellen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Crea nuovo elenco")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Создать новый список")
	if (locale === "es") return /** @type {LocalizedString} */ ("Crear nueva lista")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("创建新列表")
	if (locale === "ja") return /** @type {LocalizedString} */ ("新しいリストを作成")
	if (locale === "hi") return /** @type {LocalizedString} */ ("नई सूची बनाएँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Criar nova lista")
	return /** @type {LocalizedString} */ ("Create New List")
});